import { useEffect, useRef } from 'react';

function formatMmSs(totalSeconds) {
  const safe = Math.max(0, totalSeconds);
  const mm = Math.floor(safe / 60).toString().padStart(2, '0');
  const ss = (safe % 60).toString().padStart(2, '0');
  return `${mm}:${ss}`;
}

/**
 * Warnt vor dem Auto-Logout. Modal kann nur über die beiden Buttons
 * geschlossen werden — kein Klick außerhalb, kein X-Button. Enter
 * verlängert die Session, ESC meldet sofort ab.
 */
export default function InactivityWarningModal({ secondsLeft, onStay, onLogout }) {
  const stayButtonRef = useRef(null);

  useEffect(() => {
    stayButtonRef.current?.focus();
  }, []);

  useEffect(() => {
    function handleKey(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        onStay();
      } else if (e.key === 'Escape') {
        e.preventDefault();
        onLogout();
      }
    }
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [onStay, onLogout]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-slate-900/70" aria-hidden="true" />
      <div
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="inactivity-warning-title"
        className="relative w-full max-w-md rounded-lg bg-white p-6 shadow-2xl"
      >
        <h2
          id="inactivity-warning-title"
          className="text-lg font-semibold text-slate-900"
        >
          Sind Sie noch da?
        </h2>
        <p className="mt-3 text-sm text-slate-700">
          Sie werden in{' '}
          <span className="font-semibold tabular-nums text-slate-900">
            {formatMmSs(secondsLeft)}
          </span>{' '}
          automatisch abgemeldet.
        </p>
        <div className="mt-6 flex flex-wrap justify-end gap-2">
          <button type="button" className="btn-secondary" onClick={onLogout}>
            Jetzt abmelden
          </button>
          <button
            ref={stayButtonRef}
            type="button"
            className="btn-primary"
            onClick={onStay}
          >
            Eingeloggt bleiben
          </button>
        </div>
      </div>
    </div>
  );
}
